import type {FullCourse} from "@repo/sanity-utils/query-types";
import {getKeyedCopyText} from "@repo/utils/keyedCopy";

const COURSE_NOT_OFFERED_KEY = "course-not-offered-text";
const FALLBACK_COURSE_NOT_OFFERED =
	"This course is not offered at your selected location.";
const NOT_AVAILABLE = "N/A";

type CourseOffering = NonNullable<FullCourse>["courseOfferings"][number];

/**
 * Return error-state price lines when the selected campus is not included in
 * a modality's explicitly listed campuses.
 */
export function getUnavailableCampusPriceLines(
	offerings: CourseOffering[],
	selectedCampusId: string | null,
	keyedCopy: {key: string; text: string}[] = []
) {
	if (selectedCampusId == null) {
		return null;
	}

	const offeringCampuses = offerings.flatMap((offering) => {
		return offering.campuses ?? [];
	});
	const isUnavailable =
		offeringCampuses.length > 0 &&
		!offeringCampuses.some((campus) => {
			return campus.slug?.current === selectedCampusId;
		});

	if (!isUnavailable) {
		return null;
	}

	return {
		primary: NOT_AVAILABLE,
		secondary:
			getKeyedCopyText(keyedCopy, COURSE_NOT_OFFERED_KEY) ||
			FALLBACK_COURSE_NOT_OFFERED,
		isUnavailable: true as const,
	};
}
